import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, ListItemIcon, Menu, MenuItem, Stack, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Person2Icon from '@mui/icons-material/Person2';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { useAuth } from '../auth/Auth';
import Avatar from '../profile/info/Avatar';

const ProfileButton = () => {
    const auth = useAuth();
    const user = auth.user;
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClick = (func: () => void) => {
        return () => {
            func();
            handleClose();
        };
    };

    return (
        <>
            <Button onClick={handleOpen}>
                <Stack direction='row' alignItems='center'>
                    <Avatar user={user} size={40} />
                    <ExpandMoreIcon sx={{ color: 'white' }} />
                </Stack>
            </Button>
            <Menu
                id='profile-menu'
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <MenuItem onClick={handleClick(() => navigate('/profile'))}>
                    <ListItemIcon>
                        <Person2Icon />
                    </ListItemIcon>
                    <Typography sx={{ fontFamily: 'LemonMilk' }} textAlign='center'>
                        Profile
                    </Typography>
                </MenuItem>

                <MenuItem onClick={handleClick(auth.signout)}>
                    <ListItemIcon>
                        <ExitToAppIcon color='error' />
                    </ListItemIcon>
                    <Typography
                        sx={{ fontFamily: 'LemonMilk' }}
                        textAlign='center'
                        color='error'
                    >
                        Sign Out
                    </Typography>
                </MenuItem>
            </Menu>
        </>
    );
};

export default ProfileButton;
